import React, { useState } from 'react';
import adminDashboardImg from '../../../Assets/school_presentation/main_app_homescreen.webp';
import { useTranslation } from '../../../i18n/LanguageContext';
import HeroVideoModal from '../components/HeroVideoModal';

const HeroSection = () => {
  const { t } = useTranslation();
  const [showVideo, setShowVideo] = useState(false);
  const whatsappUrl = 'https://wa.me/916263618884?text=Hi%2C%20I%20want%20a%20demo%20of%20SpellStudy%20for%20my%20school.';

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const pillars = [
    { icon: 'fa-chart-line', label: t('landing.hero.pillars')[0] },
    { icon: 'fa-clipboard-check', label: t('landing.hero.pillars')[1] },
    { icon: 'fa-indian-rupee-sign', label: t('landing.hero.pillars')[2] },
    { icon: 'fa-mobile-screen', label: t('landing.hero.pillars')[3] },
  ];

  return (
    <section className="lp-hero" id="hero">
      <div className="lp-container">
        <div className="lp-hero-top">
          <div className="lp-hero-headline">
            <div className="lp-badge lp-badge-glass lp-hero-badge">
              <i className="fa-solid fa-graduation-cap" />
              {t('landing.hero.badge')}
            </div>

            <h1 className="lp-heading lp-heading-xl">
              {t('landing.hero.titlePrefix')}{' '}
              <span className="lp-highlight">{t('landing.hero.titleHighlight')}</span>
            </h1>
          </div>

          <div className="lp-hero-visual">
            <div className="lp-hero-frame">
              <div className="lp-hero-frame-bar" aria-hidden="true">
                <span />
                <span />
                <span />
              </div>
              <div className="lp-hero-frame-media">
                <img
                  src={adminDashboardImg}
                  alt={t('landing.hero.imageAlt')}
                  className="lp-hero-screenshot"
                  width="3278"
                  height="2332"
                  fetchPriority="high"
                  decoding="async"
                />
                <button
                  className="lp-hero-play-btn"
                  onClick={() => setShowVideo(true)}
                  aria-label={t('landing.hero.playVideo')}
                >
                  <i className="fa-solid fa-play" />
                </button>
                {showVideo && (
                  <HeroVideoModal
                    onClose={() => setShowVideo(false)}
                    fullscreenOnOpen={window.matchMedia('(max-width: 768px)').matches}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="lp-hero-below">
          <p className="lp-subheading">
            {t('landing.hero.subtitle')}
          </p>

          <div className="lp-hero-offer">
            {t('landing.hero.offer')}
          </div>

          <div className="lp-hero-actions">
            <button className="lp-btn lp-btn-primary" onClick={() => scrollTo('contact')}>
              <i className="fa-solid fa-calendar-check" />
              {t('landing.hero.bookDemo')}
            </button>
            <a className="lp-btn lp-btn-secondary lp-btn-whatsapp" href={whatsappUrl} target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-whatsapp" />
              {t('landing.hero.whatsAppDemo')}
            </a>
          </div>

          <div className="lp-hero-meta">
            <div className="lp-hero-pillars">
              {pillars.map((p, i) => (
                <div className="lp-hero-pillar" key={i}>
                  <div className="lp-hero-pillar-icon">
                    <i className={`fa-solid ${p.icon}`} />
                  </div>
                  <span>{p.label}</span>
                </div>
              ))}
            </div>

            <div className="lp-hero-trust">
              <i className="fa-solid fa-check-circle" />
              {t('landing.hero.trust')}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
